[
 {
  "id": "back",
  "x": 20,
  "y": 20,
  "w": 102,
  "h": 100
 },
 {
  "id": "sound",
  "x": 818,
  "y": 20,
  "w": 106,
  "h": 102
 },
 {
  "id": "logo",
  "x": 236,
  "y": 20,
  "w": 504,
  "h": 330
 },
 {
  "id": "doodle.left",
  "x": 26,
  "y": 134,
  "w": 190,
  "h": 190
 },
 {
  "id": "doodle.right",
  "x": 796,
  "y": 190,
  "w": 138,
  "h": 182
 },
 {
  "id": "title",
  "x": 146,
  "y": 830,
  "w": 710,
  "h": 200
 },
 {
  "id": "continue",
  "x": 170,
  "y": 1250,
  "w": 602,
  "h": 132
 },
 {
  "id": "rule",
  "x": 294,
  "y": 1459,
  "w": 354,
  "h": 17
 },
 {
  "id": "doodle.bottomleft",
  "x": 12,
  "y": 1450,
  "w": 158,
  "h": 154
 },
 {
  "id": "doodle.bottomright",
  "x": 756,
  "y": 1474,
  "w": 174,
  "h": 142
 },
 {
  "id": "cells",
  "x": 130,
  "y": 1114,
  "w": 680,
  "h": 128
 }
]